import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function AboutSection() {
  return <section className="py-20 md:py-28 lg:py-32 bg-brand-black" data-id="element-6">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20" data-id="element-7">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-stretch" data-id="element-8">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative order-2 lg:order-1" data-id="element-9">
            {/* Decorative accent bar top-left */}
            <div className="absolute -top-3 -left-3 w-24 h-1 bg-brand-accent z-20" data-id="element-10" />
            <div className="absolute -top-3 -left-3 w-1 h-24 bg-brand-accent z-20" data-id="element-11" />

            {/* Main photo container — matches text height */}
            <div className="relative h-[500px] lg:h-full min-h-[500px] w-full rounded-lg overflow-hidden border border-brand-border bg-brand-grey" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/jydB7R7wHk9BHtFHJPM3kc/download.png" alt="Ionuț Drăgănescu — Mentor Meserii Tehnice" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-13" />
              {/* Gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-brand-black/70 via-brand-black/10 to-transparent" data-id="element-14" />

              {/* Name tag overlay */}
              <div className="absolute bottom-6 left-6 z-10" data-id="element-15">
                <div className="bg-brand-black/70 backdrop-blur-sm px-5 py-3 rounded border border-brand-border" data-id="element-16">
                  <span className="font-heading font-bold text-brand-white text-sm uppercase tracking-industrial" data-id="element-17">
                    Ionuț Drăgănescu
                  </span>
                  <span className="block font-body text-brand-accent text-xs mt-0.5" data-id="element-18">
                    Inginer · Mentor · Coach
                  </span>
                </div>
              </div>
            </div>

            {/* Decorative accent bar bottom-right */}
            <div className="absolute -bottom-3 -right-3 w-24 h-1 bg-brand-accent z-20" data-id="element-19" />
            <div className="absolute -bottom-3 -right-3 w-1 h-24 bg-brand-accent z-20" data-id="element-20" />

            {/* Small secondary photo overlapping bottom-right */}
            <div className="absolute -bottom-6 -right-6 w-40 h-40 md:w-48 md:h-48 rounded-lg overflow-hidden border-2 border-brand-accent shadow-2xl z-10 hidden md:block" data-id="element-21">
              <img src="https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?w=400&q=80&auto=format&fit=crop" alt="Sudură TIG — experiență reală" className="w-full h-full object-cover" data-id="element-22" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2" data-id="element-23">
            <h2 className="font-heading font-black text-3xl md:text-4xl text-brand-white uppercase tracking-industrial mb-2" data-id="element-24">
              Ionuț Drăgănescu
            </h2>
            <h3 className="font-sub font-medium italic text-brand-muted text-lg mb-10" data-id="element-25">
              Inginer · Mentor Meserii Tehnice · Coach · Project Manager PMP
            </h3>

            <div className="space-y-6 font-body text-brand-muted text-lg leading-relaxed mb-12" data-id="element-26">
              <p data-id="element-27">
                Sunt Ionuț Drăgănescu și de peste 22 de ani lucrez în domeniul
                instalațiilor. De la pipefitting industrial la sudură TIG, de la
                instalații sanitare și termice la coordonarea proiectelor mari
                de construcții.
              </p>
              <p data-id="element-28">
                Am fost pe șantiere în România și în Europa. Am condus echipe.
                Am făcut estimări de costuri, ofertări și am livrat proiecte de
                la A la Z.
              </p>
              <p data-id="element-29">
                Acum îmi folosesc toată experiența pentru a ghida bărbații care
                vor să învețe o meserie stabilă, bine plătită și cu viitor. Nu
                predau doar teorie. Te iau de mână și îți arăt exact ce trebuie
                să știi ca să te angajezi și să te descurci pe orice șantier.
              </p>
              <p data-id="element-30">
                Sunt certificat ca Coach, Business Mentor și Project Manager
                PMP. Combin cunoștințele tehnice de pe teren cu mentorat adaptat
                pe fiecare cursant în parte.
              </p>
            </div>

            <div className="bg-brand-dark border border-brand-border rounded-lg p-8" data-id="element-31">
              <h4 className="font-heading font-bold text-xl text-brand-white uppercase tracking-industrial mb-6" data-id="element-32">
                Misiunea mea
              </h4>
              <ul className="space-y-4" data-id="element-33">
                {['De la necunoaștere la stăpânirea meseriei', 'De la nesiguranță la încredere reală în tine', 'De la instabilitate la un job stabil și bine plătit'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-34">
                    <CheckCircle2Icon className="w-6 h-6 text-brand-accent shrink-0 mt-0.5" data-id="element-35" />
                    <span className="font-body text-brand-white font-semibold text-lg" data-id="element-36">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <a href="https://wa.link/udb2nf" target="_blank" rel="noopener noreferrer" className="inline-block mt-8 bg-transparent border border-brand-accent text-brand-accent font-heading font-bold uppercase tracking-industrial px-8 py-4 rounded-[4px] hover:bg-brand-accent hover:text-brand-black transition-all duration-300 text-sm" data-id="element-37">
              Vezi mai multe detalii despre mine
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}